<template>
  <div class="container">
    <div class="basic-page-container">
      <div class="divide"></div>
      <div class="basic-name-code">
        <el-input class="basic-page-name"
          @input="handleTitleInput"
          placeholder="输入网页素材名字"
          v-model="basicPage.name"
          show-word-limit />
        <div class="divide"></div>
        <el-input class="basic-page-code"
          @input="handleCodeInput"
          v-model="basicPage.code"
          placeholder="输入网页素材标识"/>
      </div>
      <div class="divide"></div>
      <el-input class="basic-page-description"
        @input="handleDescriptionInput"
        v-model="basicPage.description"
        placeholder="输入网页素材描述"/>
      <div class="divide"></div>
      <div class="form-contant-field">
        <RichTextEditor class="editor-wrap" 
          placeholder="输入网页素材内容"
          v-model="basicPage.content"
          :isBasicPage="true"
          :maxChars="maxContentLength"
          :editable="editable"
          @getContentLength="getContentLength" />
      </div>
      <div class="divide"></div>
    </div>
    <div class="fixed-bottom">
      <div>
        <el-button round @click="handleCancel">取消</el-button>
        <el-button v-if="mode === 'create'" type="primary" round @click="handleAdd">新增</el-button>
        <el-button v-if="mode === 'edit'" type="primary" round @click="handleEdit">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import RichTextEditor from '@/components/rich-text-editor/index.vue';
  import { getBasicPageById, addBasicPage, editBasicPage } from "@/api/basic/basicpage";
  export default {
    data() {
      return {
        mode: 'create',
        basicPage: {
          id: '',
          name: '',
          description: '',
          code: '',
          content: '',
          contentType: 1
        },
        maxContentLength: 20000,
      }
    },
    components: {
      RichTextEditor,
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        if (this.$route.query.id) {
          this.mode = 'edit';
          this.basicPage.id = this.$route.query.id;
        } else {
          return;
        }
        await this.getBasicPage();
      },
      handleAdd() {
        let params = {
          name: this.basicPage.name,
          description: this.basicPage.description,
          code: this.basicPage.code,
          content: this.basicPage.content,
          contentType: 1,
        };
        if (!params.name) {
          this.$message.error("网页素材名字不能为空");
          return;
        }
        if (!params.code) {
          this.$message.error("网页素材标识不能为空");
          return;
        }
        addBasicPage(params).then((res) => {
          if (res.data.data) {
            this.$message.success("添加成功");
            this.$router.push({
              path: '/basicpage/list'
            })
          } else {
            this.$message({
              showClose: true,
              message: "添加失败",
              type: error
            })
          }
        })
      },
      handleCancel() {
        this.$router.push({
          path: '/basicpage/list'
        })
      },
      handleEdit() {
        let params = {
          id: this.basicPage.id,
          name: this.basicPage.name,
          description: this.basicPage.description,
          code: this.basicPage.code,
          content: this.basicPage.content,
        };
        if (!params.name) {
          this.$message.error("网页素材名字不能为空");
          return;
        }
        if (!params.code) {
          this.$message.error("网页素材标识不能为空");
          return;
        }
        editBasicPage(params).then((res) => {
          if (res.data.data === true) {
            this.$router.push({ path: '/basicpage/list' });
            this.$message.success('修改成功');
          } else {
            this.$message({
              showClose: true,
              message: '修改失败',
              type: error
            });
          }
        });
      },
      getBasicPage() {
        getBasicPageById(this.basicPage.id).then((res) => {
          if (res.data.code === 0) {
            this.basicPage = res.data.data;
          }
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
.container {
  padding: 8px 10px;
  border-radius: 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #fff;
  .basic-page-container{
    margin-right: 20px;
    margin-left: 20px;
    margin-bottom: 60px;
    .basic-name-code{
      display: flex;
      width: 100%;
      .basic-page-name{
        border-radius: 8px;
        width: 50%;
      }
      .basic-page-code{
        border-radius: 8px;
        width: 50%;
        margin-left: 10px;
      }
    }
  }
  .divide {
    height: 10px;
  }
  .fixed-bottom {
    position: fixed;
    right: 10px;
    bottom: 0;
    width: 100%;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
    padding: 20px 70px 20px 40px;
    background: #fff;
  }

}
</style>